module.exports = __webpack_public_path__ + "assets/img/driver-btn-b137b3eb.png";